import { Component, OnInit, Output } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import {
  DialogRef,
  ModalComponent,
  overlayConfigFactory
} from "angular2-modal";
import { BSModalContext, Modal } from "angular2-modal/plugins/bootstrap";
import { TranslateService } from "ng2-translate/ng2-translate";
import { Subject, Subscription } from "rxjs";
import { SendMoneyDetail } from "../../models/sendmoney/sendmoney";
import {
  enumEventype,
  UserProfileTMNIovation
} from "../../models/user/user.tm.profile.model";
import { CountryService } from "../../sharedcomponents/commonservice/countrylist.service";
import { utilityService } from "../../sharedcomponents/commonservice/utility.service";
import {
  AppSettings,
  enumStatusCodeList
} from "../../sharedcomponents/_common/constants/app.constants";
import { CountryDetail } from "../../sharedcomponents/_common/countrylist/countryinformation";
import { ErrorPopupComponent } from "../../sharedcomponents/_directive/error-popup/error-popup.component";
import { SendMoneyService } from "../../_services/sendmoneyservice/sendmoneyservice";
import { AuthService } from "../../_services/userservice/auth.service";
import { StatelistComponent } from "../../sharedcomponents/_common/countrylist/statelist.component";
import { CitylistComponent } from "../../sharedcomponents/_common/countrylist/citylist.component";

export class CustomModalContext extends BSModalContext {
  public bd: any;
}

@Component({
  selector: "app-add-edit-beneficiary",
  templateUrl: "./add-edit-beneficiary.component.html",
  styleUrls: ["./add-edit-beneficiary.component.css"],
  providers: [Modal, CountryService, AuthService]
})
export class AddEditBeneficiaryComponent
  implements OnInit, ModalComponent<CustomModalContext> {
  userProfileTMNIovation: UserProfileTMNIovation;
  context: CustomModalContext;
  sendMoneyDetail: SendMoneyDetail;
  model: any = {};
  beneficiarySuccessRes: any = {};
  countryCollection: any;
  stateCollection: any;
  cityCollection: any;
  loading = false;
  mobilePre = "0";
  title = "Add Beneficiary";
  countryinfo: CountryDetail;
  action = false;
  appSettings: any = {};
  subFraud: Subscription;
  private subProfile = new Subject<boolean>();
  @Output()
  subProfileObservable = this.subProfile.asObservable();
  phoneminLength;
  phonemaxLength;
  phonepattern;
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private router: Router,
    private modal: Modal,
    private sendMoneyService: SendMoneyService,
    private countryserv: CountryService,
    public utilitySer: utilityService,
    private auth: AuthService,
    public translate: TranslateService
  ) {
    this.context = dialog.context;
    this.context.dialogClass = "addeditPopup";
    this.appSettings = AppSettings;
    this.countryCollection = this.countryserv.getCountryListFromLocale();
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    // this.model.mobilePrefix = this.mobilePre;
    this.model.state = "";
    this.model.city = "";

    if (this.dialog.context.bd.callType === "add") {
      this.model.country = this.sendMoneyDetail.pickupTypeDetails.countryPreference;
      this.title = this.translate.instant("AddBeneficiary_title");
      this.model.BeneficiaryId = 0;
    } else {
      this.model = this.dialog.context.bd;
      this.title = this.translate.instant("EditBeneficiary_title");
    }
  }

  ngOnInit() {
    this.phoneminLength = AppSettings.phoneminLength;
    this.phoneminLength = AppSettings.phonemaxLength;
    this.phonepattern = `[0-9]{${AppSettings.phoneminLength}}`;
    this.onCountryChange(this.model.country);
    this.populateState();



  }

  openStateBox() {
    let self = this;
    let modalData: any = {};
    modalData.CountryCode = this.model.country;
    return this.modal
      .open(
        StatelistComponent,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function(obj) {
        obj.onDestroy.subscribe(data => {
          if (modalData.next.StateCode == undefined) {
          } else {
            self.model.state = modalData.next.StateCode;
            // self.branchData.State = modalData.next.StateName;
            self.ddlStateOnChange(modalData.next.StateCode);
            // self.openCityBox();
          }
        });
      });
  }

  openCityBox() {
    let self = this;
    let modalData: any = {};
    modalData.CountryCode = this.model.country;
    modalData.StateCode = this.model.state;
    return this.modal
      .open(
        CitylistComponent,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function(obj) {
        obj.onDestroy.subscribe(data => {
          if (modalData.next.City == undefined) {
          } else {
            self.model.city = modalData.next.City;
            // self.searchForBranch();
          }
        });
      });
  }

  ddlStateOnChange(stateCode) {
    if (stateCode == "") {
      this.cityCollection = [];
      return;
    }
    this.cityCollection = this.stateCollection.filter(function(state) {
      return state.statecode === stateCode;
    })[0].CountryCity;
    if (this.cityCollection != null) {
      // this.model.city = this.cityCollection[0];
    }
  }
  // ddlStateOnChange(stateCode) {
  //   this.cityCollection = this.stateCollection.filter(function(state) {
  //     return state.statecode === stateCode;
  //   })[0].CountryCity;
  //   if (this.cityCollection != null) {
  //     this.model.City = this.cityCollection[0];
  //   }
  // }

  AddEditBeneficiary() {

    this.loading = true;
    const _self = this;

    this.utilitySer.busy = this.sendMoneyService.addBeneficiary(this.model).subscribe(data => {
        const resJSON = data;
        if (
          resJSON.Envelope.Body.BeneficiaryResponse.StatusCode == 20001
        ) {
          return false;
        }
        if (
          resJSON.Envelope.Body.BeneficiaryResponse.StatusCode ==
          enumStatusCodeList.UserIsAlreadyExist
        ) {
          this.loading = false;
          let modalData: any = {};
          modalData.Title = this.translate.instant("Common_lblOops");
          modalData.Message =
            resJSON.Envelope.Body.BeneficiaryResponse.StatusMessage;
          return this.modal
            .open(
              ErrorPopupComponent,
              overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function(obj) {
              obj.onDestroy.subscribe(data => {
                _self.dialog.close();
              });
            });
        } else if (
          resJSON.Envelope.Body.BeneficiaryResponse.StatusCode ==
          enumStatusCodeList.SUCCESS
        ) {
          this.loading = false;
          this.dialog.close();
        } else {
          let modalData: any = {};
          modalData.Title = this.translate.instant("Common_lblOops");
          modalData.Message =
            resJSON.Envelope.Body.BeneficiaryResponse.StatusMessage;
          return this.modal
            .open(
              ErrorPopupComponent,
              overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function(obj) {
              obj.onDestroy.subscribe(data => {
                _self.dialog.close();
              });
            });
        }
      },
      error => {
        console.log("Observer got a next value: " + error);
      });
  }

  onCountryChange(contryCode) {
    const countryObj = this.countryCollection.filter(function(country) {
      return country.CountryCode === contryCode;
    });
    if (countryObj.length > 0) {
      this.model.mobilePrefix = countryObj[0].CountryDialingCode;
      this.phoneminLength = countryObj[0].PhoneNumberLength;
      this.phoneminLength = countryObj[0].PhoneNumberLength;
      this.phonepattern = `[0-9]{${this.phoneminLength}}`;
    } else {
      this.model.mobilePrefix = this.mobilePre;
    }

  }
  populateState() {
    const countryCode = this.model.country; //'MX';//this.sendMoneyDetail.pickupTypeDetails.countryPreference;
    const coll = this.countryCollection.filter(function(country) {
      return country.CountryCode === countryCode;
    });
    if (coll.length > 0) {
      this.stateCollection = coll[0].CountryState;
      if (this.dialog.context.bd.callType === "edit") {
        this.ddlStateOnChange(this.model.state);
        // this.model.state = this.stateCollection[0].statecode;
      }
    }
  }

  closePopup() {
    this.dialog.close();
  }
  ngOnDestroy() {
    // if (this.action === true) {
    //   this.sendMoneyService.setModalPopup(SendMoneySteps.Beneficiary, true);
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/_add-edit-beneficiary/add-edit-beneficiary.component.ts